export default __webpack_public_path__ + "bml-characteristic3.3865a68.png";